export type AtVirtualClinicDismissalType =
  'E' | 'T' | 'S' | 'A' | 'R' | 'P' | 'L' | 'V' | 4;

export const AT_VIRTUAL_CLINIC_DISMISSAL_TYPE_DISPLAY_NAMES: { [dismissalType in AtVirtualClinicDismissalType]: string } = {
  E: 'Entlassung aus dem Krankenhaus',
  T: 'Transfer in ein anderes Krankenhaus',
  S: 'Sterbefall',
  A: 'Krankenhausinterne Verlegung vom Bereich der Rehabilitation und vom ausschließlichen Bereich der Pflege in den allgemeinen stationären Bereich (inkl. Intensivbereich)',
  R: 'Krankenhausinterne Verlegung in den Bereich der Rehabilitation',
  P: 'Krankenhausinterne Verlegung in den ausschließlichen Bereich der Pflege',
  L: 'Kennzeichen der Datensätze, die zum Zeitpunkt der Asylierung dokumentarischabgeschlossen werden',
  V: 'Kennzeichen für noch nicht abgeschlossene Aufenthalte von am Jahresende verbleibenden Patient:innen',
  4: 'Entlassung gegen Revers'
};
